export const FAVORITE_PRODUCT_REDIRECT_KEY = 'FAVORITE_PRODUCT_REDIRECT_KEY';

export interface IFavoriteRedirectData {
  redirectUrl?: string;
  productUuid?: string;
  shouldOpenFavoriteModal?: boolean;
}
